"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var classnames_1 = __importDefault(require("classnames"));
var ChevronRight_1 = __importDefault(require("@material-ui/icons/ChevronRight"));
var ChevronLeft_1 = __importDefault(require("@material-ui/icons/ChevronLeft"));
var Drawer_1 = __importDefault(require("@material-ui/core/Drawer"));
var core_1 = require("@material-ui/core");
var Divider_1 = __importDefault(require("../Divider"));
var List_1 = __importDefault(require("../List/List"));
var ListItem_1 = __importDefault(require("../List/ListItem"));
var ListItemIcon_1 = __importDefault(require("../List/ListItemIcon"));
var ListItemText_1 = __importDefault(require("../List/ListItemText"));
var IconButton_1 = __importDefault(require("../IconButton"));
var Drawer = react_1.forwardRef(function Drawer(_a, ref) {
    var _b, _c;
    var _d = _a.open, open = _d === void 0 ? false : _d, handleDrawerToggle = _a.handleDrawerToggle, _e = _a.variant, variant = _e === void 0 ? 'permanent' : _e, menuList = _a.menuList;
    var classes = useStyles();
    var renderMenuList = function () { return (jsx_runtime_1.jsx(List_1.default, { children: menuList.map(function (item, index) { return (jsx_runtime_1.jsxs(ListItem_1.default, __assign({ button: true }, { children: [jsx_runtime_1.jsx(ListItemIcon_1.default, { children: item.icon }, void 0),
                jsx_runtime_1.jsx(ListItemText_1.default, { primary: item.title }, void 0)] }), item.key || index)); }) }, void 0)); };
    return (jsx_runtime_1.jsxs(Drawer_1.default, __assign({ variant: variant, className: classnames_1.default(classes.drawer, (_b = {},
            _b[classes.drawerOpen] = open,
            _b[classes.drawerClose] = !open,
            _b)), classes: {
            paper: classnames_1.default((_c = {},
                _c[classes.drawerOpen] = open,
                _c[classes.drawerClose] = !open,
                _c)),
        }, open: open, ref: ref }, { children: [jsx_runtime_1.jsx("div", __assign({ className: classes.toolbar }, { children: jsx_runtime_1.jsx(IconButton_1.default, __assign({ onClick: handleDrawerToggle }, { children: open ? jsx_runtime_1.jsx(ChevronLeft_1.default, {}, void 0) : jsx_runtime_1.jsx(ChevronRight_1.default, {}, void 0) }), void 0) }), void 0),
            jsx_runtime_1.jsx(Divider_1.default, {}, void 0), renderMenuList(), jsx_runtime_1.jsx(Divider_1.default, {}, void 0)] }), void 0));
});
exports.default = Drawer;
var drawerWidth = 240;
var useStyles = core_1.makeStyles(function (theme) {
    var _a;
    return ({
        drawer: {
            width: drawerWidth,
            flexShrink: 0,
            whiteSpace: 'nowrap',
        },
        drawerOpen: {
            width: drawerWidth,
            transition: theme.transitions.create('width', {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.enteringScreen,
            }),
        },
        drawerClose: (_a = {
                transition: theme.transitions.create('width', {
                    easing: theme.transitions.easing.sharp,
                    duration: theme.transitions.duration.leavingScreen,
                }),
                overflowX: 'hidden',
                width: theme.spacing(7) + 1
            },
            _a[theme.breakpoints.up('sm')] = {
                width: theme.spacing(9) + 1,
            },
            _a),
        toolbar: __assign({ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', padding: '0 8px' }, theme.mixins.toolbar),
    });
});
//# sourceMappingURL=Drawer.js.map